import { AlpineComponent } from 'alpinejs';
import { Loader } from "@googlemaps/js-api-loader"

type GoogleMapsData = {
  elementId: string;
  apiKey: string;
  mapId: string;
  latitude: string;
  longitude: string;
  markerType: string;
  geocoder: google.maps.Geocoder | null;
  initMap: () => void;
  map: google.maps.Map | null;
}

export default (elementId: string, apiKey: string, mapId: string, latitude: string, longitude: string, markerType :string):AlpineComponent<GoogleMapsData> => ({
  elementId,
  apiKey,
  mapId,
  latitude,
  longitude,
  markerType,
  geocoder: null,
  map: null,

  init() {
    this.initMap();
  },

  async initMap() {
    const loader = new Loader({
      apiKey: this.apiKey,
      version: "weekly",
    });

    loader.load().then(async () => {
      const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
      const { Geocoder } = await google.maps.importLibrary("geocoding") as google.maps.GeocodingLibrary;

      // Map
      const googleMap = document.getElementById(elementId) as HTMLElement;
      if (googleMap) {
        const map = new Map(googleMap, {
          center: { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) },
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          zoom: 14,
          disableDefaultUI: true,
          scrollwheel: false,
          mapTypeControl: false,
          scaleControl: false,
          mapId: this.mapId,
        });

        // Marker
        const markerImg = document.createElement('img');
        markerImg.src = '/wp-content/themes/template/resources/Public/icons/marker.' + this.markerType + '.svg';
        const marker = new AdvancedMarkerElement({
          map,
          position: { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) },
          content: markerImg,
        });
        if (marker && marker.content) {
          (marker.content as HTMLElement).classList.add("bounce");
        }

        // Update Google map
        if (googleMap && googleMap.parentElement && googleMap.parentElement.parentElement) {
          const mapWrapper = googleMap.parentElement.parentElement as HTMLElement;
          if (mapWrapper) {
            const btn = mapWrapper.querySelector('.update-google-maps') as HTMLElement;
            btn.addEventListener("click", (event) => {
              event.preventDefault();

              const formTarget = btn.dataset.id;
              if (formTarget) {
                const form = document.getElementById(formTarget) as HTMLElement;
                if (form) {
                  let address = '';
                  const street = form.querySelector('#street') as HTMLInputElement | null;
                  const postalCode = form.querySelector('#postal_code') as HTMLInputElement | null;
                  const city = form.querySelector('#city') as HTMLInputElement | null;
                  const mapAddress = form.querySelector('#maps-address') as HTMLInputElement | null;
                  if (mapAddress) {
                    address = mapAddress.value;
                  } else {
                    if (street && postalCode && city) {
                      address = street.value + ', ' + postalCode.value + ', ' + city.value;
                    }
                  }

                  //console.log(address);

                  const geocoder = new Geocoder();
                  geocoder.geocode({'address': address}, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                      let location;
                      if (results) {
                        location = results[0].geometry.location;
                        const latitude = form.querySelector('#latitude') as HTMLInputElement | null;
                        const longitude = form.querySelector('#longitude') as HTMLInputElement | null;
                        if (latitude) {
                          latitude.value = location.lat().toString();
                        }
                        if (longitude) {
                          longitude.value = location.lng().toString();
                        }

                        map.setCenter(location);
                        marker.position = location;
                      }

                    } else {
                      console.log('Geocode was not successful for the following reason: ' + status);
                    }
                  });
                }
              }
            });
          }
        }
      } else {
        console.error("Map element not found");
      }
    });
  },
});
